import { render, staticRenderFns } from "./userCollectionLogout.vue?vue&type=template&id=d0c8d29c&"
import script from "./userCollectionLogout.vue?vue&type=script&lang=js&"
export * from "./userCollectionLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports